import { createSelector } from 'react-sweet-state';

import type { FormRendererState } from '../../types';

/*
 * Selector to get the attachment configuration
 */
export const attachmentConfigurationSelector: import('react-sweet-state').OutputSelector<
	FormRendererState,
	void,
	import('../../../..').AttachmentConfiguration | undefined
> = createSelector(
	(state: FormRendererState) => state.attachmentConfiguration,
	(configuration) => configuration,
);
